// https://blog.sqreen.com/authentication-best-practices-vue/
// https://github.com/sqreen/vue-authentication-example/blob/master/src/store/actions/auth.js

export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
